'use strict';

/*jshint unused: false*/
var imgHeroComponent = {
  bindings: {
    model: '=',
    isPreviewVisible: '=',
  },
  controller: /*@ngInject*/ function (TransferService, $element) {
    var _self = this;
    _self.type = $element.attr('type');
    _self.isLoading = true;

    _self.handleLoad = function () {
      _self.isLoading = false;
    };

    _self.saveLineArt = function () {
      switch (_self.model.type) {
        case 'FCO':
          return TransferService.downloadAssets(_self.model.name);
        case 'Color Reference':
          return TransferService.saveFile(_self.model.src, _self.model.name);
        default:
          return TransferService.saveLineArt({
            url: _self.model.src,
            name: _self.model.name,
            viewCode: _self.model.viewCode,
          });
      }
    };

    _self.closeModal = function () {
      _self.isLoading = true;
      _self.isPreviewVisible = false;
      _self.model = {
        active: false,
        src: '',
        name: '',
        type: '',
      };
    };
  },
  templateUrl: 'templates/partials/ui/imgHeroComponent.tpl.html',
};

module.exports = imgHeroComponent;
